import { render, staticRenderFns } from "./partment.vue?vue&type=template&id=5c1e6f62"
import script from "./partment.vue?vue&type=script&lang=js"
export * from "./partment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports